import React, {forwardRef} from "react";
import {Select} from "antd";

interface FormSelectProps {
    key: string;
    formText: string;
    placeholder?: string;
    required?: boolean;
    options: { label: string; value: string }[];
    value?: string;
    [key: string]: any;
}

const FormSelect = forwardRef<any, FormSelectProps>((props, ref) => {
    const { formText, required, options, value, key, ...rest } = props;

    return (
        <div className="form-container">
      <span className="form-text">
        {formText}{" "}
          <span className="required-text">{required ? "*" : ""}</span>{" "}
      </span>
            <Select
                key={key}
                className="form-input"
                value={value}
                options={options}
                ref={ref}
                {...rest}
            />
        </div>
    );
});

FormSelect.displayName = "FormSelect";

export default FormSelect;
